(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ecosystem-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.querySelector('[data-ecosystem-banner]');
    if (!banner || banner.dataset.initialized === 'true') return;

    banner.dataset.initialized = 'true';
    const storageKey = 'bg-ecosystem-banner-hidden-until';
    let hiddenUntil = 0;

    try {
      hiddenUntil = Number.parseInt(localStorage.getItem(storageKey) || '0', 10);
    } catch {}

    if (hiddenUntil > Date.now()) {
      banner.remove();
      return;
    }

    const now = Date.now();
    const items = Array.from(banner.querySelectorAll('[data-ecosystem-item]')).filter((item) => {
      const expiresAt = item.dataset.expires ? Date.parse(item.dataset.expires) : Number.NaN;
      const expired = Number.isFinite(expiresAt) && expiresAt < now;
      if (expired) item.remove();
      return !expired;
    });

    if (items.length === 0) {
      banner.remove();
      return;
    }

    let activeIndex = 0;
    let intervalId;

    const activate = (index) => {
      items.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        item.tabIndex = active ? 0 : -1;
      });
    };

    const stopWaiting = () => {
      window.removeEventListener('scroll', reveal);
      window.removeEventListener('pointerdown', reveal);
      window.removeEventListener('keydown', reveal);
    };

    const reveal = () => {
      banner.classList.add('is-visible');
      stopWaiting();

      if (items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        intervalId = window.setInterval(() => {
          activeIndex = (activeIndex + 1) % items.length;
          activate(activeIndex);
        }, 6500);
      }
    };

    activate(0);
    window.addEventListener('scroll', reveal, { passive: true });
    window.addEventListener('pointerdown', reveal, { passive: true });
    window.addEventListener('keydown', reveal);

    banner.querySelector('[data-ecosystem-close]')?.addEventListener('click', () => {
      if (intervalId) window.clearInterval(intervalId);

      try {
        localStorage.setItem(storageKey, String(Date.now() + 604800000));
      } catch {}

      banner.remove();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
